import { creditCard, deposit, reciveAndPay } from '@/shared/enums/wayPayment';
import BankAccounts from '@/class/BankAccount';

class PaymentsMethods {
	constructor(paymentsMethods, bankAccounts) {
		this.intialBankAccounts = bankAccounts.map(item => new BankAccounts(item));
		this.paymentsMethods = paymentsMethods;
		this.bankAccounts = this.intialBankAccounts.reduce((obj, item) => {
			const acc = obj;
			const bankId = item.getBankId();
			if (acc[bankId]) {
				acc[bankId] = [].concat(acc[bankId], item);
			} else {
				acc[bankId] = [item];
			}
			return acc;
		}, {});
	}
	getBanks() {
		return this.bankAccounts;
	}
	getBankAccounts(bankId) {
		return this.bankAccounts[bankId];
	}
	getPaymentsMethods() {
		return this.paymentsMethods;
	}
	getSelectedBank(bankId) {
		if (bankId) {
			const currentBank = this.bankAccounts.find(b => b.getBankId() === bankId);
			return currentBank;
		}
		return this.bankAccounts[0];
	}
	showBankDeposit() {
		return this.paymentsMethods.some(p => p.code === deposit.code);
	}
	showCreditCard() {
		return this.paymentsMethods.some(p => p.code === creditCard.code);
	}
	showPayUponReceipt() {
		return this.paymentsMethods.some(p => p.code === reciveAndPay.code);
	}
}

export default PaymentsMethods;



// WEBPACK FOOTER //
// ./src/class/PaymentsMethods.js